import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import generatedDataImg from "Assets/Svg/generate-data.svg";
import PageHeader from "Component/Headers/pageHeader";
import moment from "moment";
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import LoaderComponent from "Component/Loader/index";
import SectionHeaderExtraSmall from "Component/Headers/sectionHeaderExtraSmall";
import { withSnackbar } from "notistack";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import emptylist from "Assets/Svg/payroll-run-attendance-image-1.svg";
import get from "lodash/get";
import find from "lodash/find";
import uniqBy from "lodash/uniqBy";
import React from "react";
import { connect } from "react-redux";
import { Paper } from "@material-ui/core";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import DynamicForm from "Component/DynamicForm";
import DrawerHeader from "Component/Headers/drawerHeader";
import Drawer from "@material-ui/core/Drawer";
import SearchSq from "Component/Material-ui/SearchSq";
import IconWithBackground from "Component/Icons/iconWithBackground";
import ProfilePictureSmall from "Component/Thumbnail/ProfilePictureSmall";
import ProfilePictureExtraSmall from "Component/Thumbnail/ProfilePictureExtraSmall";
import DefaultProfileImage from "Assets/Images/profile_defaultImg.svg";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import rightArrow from "Assets/newicons/arrow/chevron/right/outline/chevron-right-outline-16px.svg";
import downArrow from "Assets/newicons/arrow/chevron/down/outline/chevron-down-outline-16px.svg";
import Collapse from "@material-ui/core/Collapse";
import { instance } from "Actions/AxiosInstance";
import {
  getFormattedImageLink,
  convertDateForBackend,
  getMonthName,
} from "Utils";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import { ErrorMessages } from "Constants";
import downloadIcon from "Assets/newicons/action/download/outline/download-outline-16px.svg";
import { getOptArr, onlyUnique } from "Utils/arr";
import { Doughnut } from "react-chartjs-2";
import Bankingform from "./Bankingform";
import "./index.css";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { FormattedMessage } from "react-intl";
import CircularProgress from "@material-ui/core/CircularProgress";

const styles = () => ({
  drawerPaper: {
    width: 356,
  },
});


export const ExportArrearsXLSX = (props = {}) => {
  const { rows = [], name } = props;
  const filename = `Attendance_Log_${getMonthName(name.split("-")[0])}_${
    name.split("-")[1]
    }.xlsx`;
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const headers = ["fullname"];
  rows[0] &&
    Object.keys(rows[0]).forEach((key, i) => {
      if (i > 0) {
        headers.push(`shiftdate${i}`);
      }
    });
  headers.push("totaldays");
  headers.push("presentdays");
  headers.push("leavedays");
  headers.push("absentdays");
  const ws = XLSX.utils.json_to_sheet([...rows], {
    header: headers,
    skipHeader: true,
  });
  /* hide employeeid column */
  // ws["!cols"] = [];
  // ws["!cols"][7] = { hidden: true };
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, filename);
};

class CustomToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(props.date),
    };
  }

  render() {
    const { label } = this.props;
    return (
      <div className="rbc-toolbar">
        <div className="calender-head">
          <label className="label-date">{label}</label>
        </div>
      </div>
    );
  }
}

const ToolBars = ({ min, max }) => {
  console.log("min, max: ", min, max);
  return class CustomToolbar1 extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        date: new Date(props.date),
      };
    }

    render() {
      const { label } = this.props;
      console.log("min, max1222: ", min, max);
      return (
        <div className="rbc-toolbar1">
          <div className="calender-head">
            {moment(this.state.date).format("MM") ==
              moment(max).format("MM") && (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  onClick={() => this.props.onNavigate("PREV")}
                >
                  <path fill="none" d="M0 0h24v24H0V0z" />
                  <path
                    fill="#fff"
                    d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
                  />
                </svg>
              )}
            <label className="label-date">{label}</label>
            {moment(this.state.date).format("MM") ==
              moment(min).format("MM") && (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  onClick={() => this.props.onNavigate("NEXT")}
                >
                  <path fill="none" d="M0 0h24v24H0V0z" />
                  <path
                    fill="#fff"
                    d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                  />
                </svg>
              )}
          </div>
        </div>
      );
    }
  };
};

const localizer = momentLocalizer(moment);

const STRUCTUREPOSTDATA = {
  salarystructureid: null,
  salaryamount: null,
};

class AnalysedData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: 0,
      fromdate: "",
      todate: "",
      defaultdate: "",
      scanningCompleted: false,
      iserror: true,
      drawerOpen: false,
      attendanceDrawerOpen: false,
      paymentDetails: true,
      isexpanded: false,
      loading: false,
      errors: null,
      selectedEmp: "",
      paymentmethods: [
        { paymentmethodid: 1, name: "Bank transfer" },
        { paymentmethodid: 2, name: "Cheque" },
        { paymentmethodid: 1, name: "Cash" },
      ],
      salarystructures: [],
      empdata: [],
      employeeData: [],
      structurepostdata: STRUCTUREPOSTDATA,
      chartdataLabels: [],
      chartdataValue: [],
      alldata: [],
      searchValue: null,
      noattendance: false,
    };

    this.closeMissingInfoDrawer = this.closeMissingInfoDrawer.bind(this);
    this.openMissingInfoDrawer = this.openMissingInfoDrawer.bind(this);
    this.openAttendanceDrawer = this.openAttendanceDrawer.bind(this);
    this.closeAttendanceDrawer = this.closeAttendanceDrawer.bind(this);
    this.geterrors = this.geterrors.bind(this);
    this.eventStyleGetter = this.eventStyleGetter.bind(this);
    this.setdrawerData = this.setdrawerData.bind(this);
    this.getSalayStructures = this.getSalayStructures.bind(this);
    this.getAttendanceLog = this.getAttendanceLog.bind(this);
    this.getAllNoAttendanceData = this.getAllNoAttendanceData.bind(this);
    this.getData = this.getData.bind(this);
    this.autoUnPaid = this.autoUnPaid.bind(this);
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
    this.getAllNoAttendanceData();
  }

  getAllNoAttendanceData() {
    instance
      .get("payroll/getnoattconfig")
      .then((result) => {
        this.setState(
          {
            noattendance:
              (result.data.result[0] && result.data.result[0].noattendance) ||
              false,
          },
          () => this.geterrors(true),
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getData(id, ismultiple = false, isskip = false) {
    console.log("id: ", id);
    const { errors } = this.state;
    console.log("errors: ", errors);
    console.log("this.state.drawerType: ", this.state.drawerType);
    if (this.state.drawerType === "banking" && !ismultiple) {
      const index =
        errors.empbanking &&
        errors.empbanking.findIndex((x) => x.employeeid == id);
      if (index > -1) {
        errors.empbanking.splice(index, 1);
      }
    }
    if ((this.state.drawerType === "banking" && ismultiple) || isskip) {
      id.map((x) => {
        const index =
          errors.empbanking &&
          errors.empbanking.findIndex((x1) => x1.employeeid == x.employeeid);
        console.log("index: ", index);
        if (index > -1) {
          errors.empbanking.splice(index, 1);
        }
      });
    }
    if (this.state.drawerType === "attendance" || isskip) {
      id.map((x) => {
        const index =
          errors.empattendance &&
          errors.empattendance.findIndex((x1) => x1.employeeid == x.employeeid);
        console.log("index: ", index);
        if (index > -1) {
          errors.empattendance.splice(index, 1);
        }
      });
    }
    if (this.state.drawerType === "salarystructure") {
      const index =
        errors.empsalary &&
        errors.empsalary.findIndex((x) => x.employeeid == id);
      if (index > -1) {
        errors.empsalary.splice(index, 1);
      }
    }

    if (isskip) {
      id.map((x) => {
        const index =
          errors.empsalary &&
          errors.empsalary.findIndex((x1) => x1.employeeid == x.employeeid);
        console.log("index: ", index);
        if (index > -1) {
          errors.empsalary.splice(index, 1);
        }
      });
    }
    this.setState({ errors });
    console.log("errors: ", errors);
  }

  getSalayStructures() {
    instance
      .get(`payroll/getallsalarystructure/0/1000`)
      .then((resp) => {
        this.setState({
          salarystructures: getOptArr({
            arr: get(resp, "data.result", []),
            displaynamekey: "structurename",
            displayvaluekey: "salarystructureid",
          }),
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });

    instance
      .get("payroll/payrollconfig")
      .then((resp) => {
        this.setState({
          payrolltypeid: get(resp, "data.result[0].payrolltypeid", ""),
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  geterrors(isFirst = false, tempArr = []) {
    const {
      salarycycle: {
        displayvalue,
        salarycycleid,
        cyclefrom,
        cycleto,
        attendancecycletypeid,
        attcustomday,
        payrollyear,
        payrollmonthid,
      },
      payrollcycle: { payrollcycledurationid, payrollcycleid },
    } = this.props;
    const { isSpeicalCase, specialEmps, normalEmps } = this.props;
    const getFromDate = () => {
      if (attendancecycletypeid) {
        if (attendancecycletypeid == 1) {
          return moment(
            `${payrollyear}-${payrollmonthid}-01`,
            "YYYY-MM-DD",
          ).format("YYYY-MM-DD");
        } else {
          return moment(
            `${payrollyear}-${payrollmonthid}-${attcustomday}`,
            "YYYY-MM-DD",
          )
            .subtract(1, "month")
            .add(1, "day")
            .format("YYYY-MM-DD");
        }
      }
      return cyclefrom;
    };
    const getToDate = () => {
      if (attendancecycletypeid) {
        if (attendancecycletypeid == 1) {
          return moment(`${payrollyear}-${payrollmonthid}-01`, "YYYY-MM-DD")
            .endOf("month")
            .format("YYYY-MM-DD");
        } else {
          return moment(
            `${payrollyear}-${payrollmonthid}-${attcustomday}`,
            "YYYY-MM-DD",
          ).format("YYYY-MM-DD");
        }
      }
      return cycleto;
    };

    const getToDateForMissing = () => {
      const date = getToDate();
      return date >= moment().format("YYYY-MM-DD")
        ? moment().format("YYYY-MM-DD")
        : date;
    };

    this.setState(
      {
        fromdate: getFromDate(),
        todate: getToDateForMissing(),
        defaultdate: getFromDate(),
        loading: true,
        time: isFirst ? 0 : 99,
      },
      () => {
        const postdata = {
          missingtypeid: null,
          salarycyclesplitid: displayvalue,
          salarycycleid,
          payrollcycledurationid,
          payrollcycleid,
          noattendance: this.state.noattendance,
          cyclefrom: getFromDate(),
          cycleto: getToDateForMissing(),
          employeeids:
            tempArr.length > 0
              ? tempArr
                .filter((x) => !x.ispayslipgenerated)
                .map((x) => x.employeeid)
              : isSpeicalCase
                ? specialEmps
                  .filter((x) => !x.ispayslipgenerated)
                  .map((x) => x.employeeid)
                : normalEmps
                  .filter((x) => !x.ispayslipgenerated)
                  .map((x) => x.employeeid),
        };
        const length = isSpeicalCase ? specialEmps.length : normalEmps.length;
        const totalseconds = length * 3;
        const secondsforintervals = totalseconds * 1000;
        console.log("secondsforintervals: ", secondsforintervals);
        if (isFirst) {
          this.interval = setInterval(
            () =>
              this.setState({
                time: this.state.time >= 99 ? 99 : this.state.time + 1,
              }),
            secondsforintervals / 100,
          );
        }

        instance
          .post("payroll/payrollmissingdata", postdata)
          .then((resp2) => {
            if (isFirst) {
              clearInterval(this.interval);
            }
            const data = get(resp2, "data.result[0]", null);
            this.setState({
              loading: false,
              time: 100,
              errors: data,
              employeelist: isSpeicalCase
                ? specialEmps.filter((x) => !x.ispayslipgenerated)
                : normalEmps.filter((x) => !x.ispayslipgenerated),
            });
          })
          .catch((error) => {
            this.setState(
              {
                time: 0,
                loading: false,
              },
              () => {
                this.props.enqueueSnackbar(
                  error.response
                    ? error.response.data.error.message
                    : error.message,
                  { variant: "error" },
                );
              },
            );
          });
      },
    );
  }

  openMissingInfoDrawer(type) {
    const { errors } = this.state;
    this.setState({
      drawerType: type,
      drawerData:
        type === "banking"
          ? errors.empbanking
          : type === "salarystructure"
            ? errors.empsalary
            : uniqBy(errors.empattendance || [], "employeeid"),
    });
    type === "salarystructure" && this.getSalayStructures();
  }

  onConfirmSkipSalaryError = () => {
    this.props.enqueueSnackbar(
      `Are you sure you want to skip ${this.state.errors.empsalary.length} employee(s) from generating payroll data?`,
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.skipSalaryErrorEmployees()}
          >
            Yes
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            No
          </Button>,
        ],
      },
    );
  }

  skipSalaryErrorEmployees = () => {
    this.props.closeSnackbar();
    const { errors, employeelist } = this.state;

    let yFilter = errors.empsalary.map(itemY => { return itemY.employeeid; });

    
    let filteredX = employeelist.filter(itemX => !yFilter.includes(itemX.employeeid));


   console.log("filteredEmp", filteredX);
   this.props.isSpeicalCase ?  this.props.updateSpecialEmps(filteredX) :  this.props.updateNormalEmps(filteredX);
  
   errors.empsalary = [];
    this.setState({errors, employeelist: filteredX});
  }


  closeMissingInfoDrawer() {
    const { errors } = this.state;
    errors.empbanking = errors.empbanking.map((x) => ({
      ...x,
      isselected: false,
      isexpanded: false,
    }));

    errors.empsalary = errors.empsalary.map((x) => ({
      ...x,
      isselected: false,
      isexpanded: false,
    }));

    errors.empattendance = errors.empattendance.map((x) => ({
      ...x,
      isselected: false,
      isexpanded: false,
    }));
    this.setState({
      drawerType: "",
      drawerData: null,
      searchkey: "",
      searchValue: null,
      errors,
    });
  }

  openAttendanceDrawer() {
    this.setState({
      attendanceDrawerOpen: true,
    });
  }

  getAttendanceLog(id) {
    const data = {
      employeeids: [id],
      fromdate: this.state.fromdate,
      todate: this.state.todate,
      // fromdate: "2019-12-01",
      // todate: "2019-12-31",
    };

    instance
      .post(`attendance/attendancelogpayroll`, data)
      .then((result) => {
        this.setState({
          alldata: result.data.result,
          empdata:
            result.data.result[0] &&
              result.data.result[0].employeeattendancelogs
              ? result.data.result[0].employeeattendancelogs.map((x) => {
                const holidaydate = x.shiftdate.split("-");
                const year = holidaydate[0];
                const month = holidaydate[1];
                const day = holidaydate[2];
                return {
                  ...x,
                  end: new Date(year, month - 1, day),
                  start: new Date(year, month - 1, day),
                };
              })
              : [],
          selectedEmp: id,
          chartdataValue:
            result.data.result[0] && result.data.result[0].overview
              ? result.data.result[0].overview
                .slice(0, 2)
                .map((x) => x.displayvalue)
              : [],
          chartdataLabels:
            result.data.result[0] && result.data.result[0].overview
              ? result.data.result[0].overview
                .slice(0, 2)
                .map((x) => x.displayname)
              : [],
        });
        // if (
        //   result.data.result[0] &&
        //   result.data.result[0].employeeattendancelogs.length < 1
        // ) {
        //   this.props.enqueueSnackbar(
        //     "No logs are available of selected employee",
        //     { variant: "error" },
        //   );
        // }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  setdrawerData(arr) {
    this.setState({ drawerData: arr });
  }

  closeAttendanceDrawer() {
    this.setState({ attendanceDrawerOpen: false });
  }

  handleExpandClick01 = () => {
    this.setState({
      isexpanded: !this.state.isexpanded,
    });
  };

  paymentDetailsComp = () => {
    const { drawerData } = this.state;
    const thisempdata = drawerData.find((x) => x.isexpanded);
    return (
      <Bankingform
        {...this.props}
        {...this.state}
        setdrawerData={this.setdrawerData}
        drawerData={drawerData}
        thisempdata={thisempdata}
        geterrors={this.geterrors}
        getData={this.getData}
        closeMissingInfoDrawer={this.closeMissingInfoDrawer}
      />
    );
  };

  submitStructureAssign = () => {
    const {
      payrolltypeid,
      drawerData,
      structurepostdata: { salaryamount, salarystructureid },
    } = this.state;
    const { salarycycle, payrollcycle, initrunpayroll } = this.props;
    const thisempdata = drawerData.find((x) => x.isexpanded);
    if (!thisempdata) {
      return;
    }
    const convertDateForBackendHere = (date) =>
      moment(date, "YYYY-MM-DD").startOf("month").format("YYYY-MM-DD");

    const { employeeid, employeesalaryid } = thisempdata;
    const enddate =
      moment(salarycycle.cyclefrom, "YYYY-MM-DD").format("MM") ==
        salarycycle.payrollmonthid
        ? salarycycle.cyclefrom
        : salarycycle.cycleto;
    const senddata = {
      payrolltypeid,
      structure: [
        {
          salarystructureid,
          effectivefrom:
            convertDateForBackend(thisempdata.doj) >=
              payrollcycle.payrollcyclestartdate &&
              convertDateForBackend(thisempdata.doj) <=
              payrollcycle.payrollcycleenddate
              ? convertDateForBackend(thisempdata.doj)
              : convertDateForBackend(payrollcycle.payrollcyclestartdate),
          employeeid,
          subscriptionfbpid: null,
          salaryamount,
        },
      ],
      salary: [
        {
          salaryamount,
          salarystructureid,
          effectivefrom:
            convertDateForBackend(thisempdata.doj) >=
              payrollcycle.payrollcyclestartdate &&
              convertDateForBackend(thisempdata.doj) <=
              payrollcycle.payrollcycleenddate
              ? convertDateForBackend(thisempdata.doj)
              : convertDateForBackend(payrollcycle.payrollcyclestartdate),
          employeeid,
          subscriptionfbpid: null,
          employeesalaryid,
          salarygrosscomponent: null,
        },
      ],
    };
    console.log("senddata: ", senddata);
    if (
      senddata.salary[0].salarystructureid &&
      senddata.structure[0].salaryamount
    ) {
      const { issaveinprogress } = this.props.SaveInProgressReducer;
      console.log("issaveinprogress: ", issaveinprogress);
      if (!issaveinprogress) {
        this.props.setSaveProgress(true);
        instance
          .post("payroll/assignemployeesalary", senddata)
          .then(() => {
            this.setState({
              drawerType:
                drawerData.filter((x) => x.isexpanded).length == 0
                  ? ""
                  : this.state.drawerType,
            });
            this.props.enqueueSnackbar(ErrorMessages.E0000, {
              variant: "success",
            });
            this.props.removeSaveProgress();
            this.setdrawerData(
              drawerData && drawerData.filter((x) => !x.isexpanded),
            );
            this.getData(employeeid);
            this.closeMissingInfoDrawer();
          })
          .catch((error) => {
            this.props.removeSaveProgress();
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          });
      }
    } else {
      this.props.enqueueSnackbar(ErrorMessages.E0020, { variant: "error" });
    }
  };

  salaryStructureDetailsComp = () => {
    const {
      structurepostdata: { salarystructureid, salaryamount },
      structurepostdata,
      salarystructures,
    } = this.state;
    return (
      <div>
        <DynamicForm
          fields={selectinputconverter({
            value: salarystructureid,
            options: salarystructures,
            placeholder: "Select salary structure",
            label: "Salary structure",
          })}
          onChange={(e) =>
            this.setState({
              structurepostdata: { ...structurepostdata, salarystructureid: e },
            })
          }
        />

        <DynamicForm
          fields={integerinputconverter({
            value: salaryamount,
            placeholder: "Enter amount",
            label: "Salary amount",
          })}
          onChange={(e) =>
            this.setState({
              structurepostdata: { ...structurepostdata, salaryamount: e },
            })
          }
        />

        <Button
          variant="contained"
          className="btn btn-primary-md-blue"
          color="primary"
          disabled={this.props.SaveInProgressReducer.issaveinprogress}
          // disabled={!salaryamount || !salarystructureid}
          onClick={this.submitStructureAssign}
        >
          Submit
        </Button>

        {/* {isselectedemployee && (
          <Button
            variant="contained"
            className="btn btn-primary-md-yellow margin-top-12 margin-bottom-12"
            color="primary"
            // onClick={this.props.onCancel}
          >
            Postpone selected
          </Button>
        )} */}
      </div>
    );
  };

  autoRegularize = () => {
    const {
      drawerData = [],
      errors: { empattendance = [] },
    } = this.state;
    const allrecords =
      empattendance &&
      empattendance.filter((x) =>
        drawerData.find((y) => y.isexpanded && y.employeeid === x.employeeid),
      );

    console.log("allrecords: ", allrecords);
    const postdata = [...allrecords]
      .map((x) => x.employeeid)
      .filter(onlyUnique)
      .map((empid) => ({
        employeeid: empid,
        regularizelog:
          allrecords &&
          allrecords.find((x) => x.employeeid == empid) &&
          allrecords.find((x) => x.employeeid == empid).attendance,
      }));
    console.log("postdata: ", postdata);

    console.log("postdata: ", postdata);
    if (postdata && postdata.length > 0) {
      const { issaveinprogress } = this.props.SaveInProgressReducer;
      console.log("issaveinprogress: ", issaveinprogress);
      if (!issaveinprogress) {
        this.props.setSaveProgress(true);
        this.props.closeSnackbar();
        const totalseconds = postdata.length * 2;
        const secondsforintervals = totalseconds * 1000;

        this.interval = setInterval(
          () => {
            this.setState({
              time: this.state.time + 1,
            });
            if (this.state.time > 99) {
              clearInterval(this.interval);
              this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
              this.setState({
                  time: 0,
                  loading: false,
                });
            }
          },
          secondsforintervals / 100,
        );
        this.setState(
          {
            time: 0,
            loading: true,
          },
          () => {
            instance
              .post("attendance/autobulkregularize", postdata)
              .then(() => {
                this.props.removeSaveProgress();
                console.log("salary slip generated");
                const newdrawerdata =
                  empattendance &&
                  empattendance.filter(
                    (x) =>
                      !drawerData.find(
                        (y) => y.isexpanded && y.employeeid === x.employeeid,
                      ),
                  );

                const employeeid = postdata.filter((x) => x.employeeid);
                this.getData(employeeid);
                if (newdrawerdata[0]) {
                  this.setdrawerData(newdrawerdata);
                } else {
                  this.closeMissingInfoDrawer();
                }
              })
              .catch((error) => {
                this.props.removeSaveProgress();
                this.setState(
                  {
                    time: 0,
                    loading: false,
                  },
                  () => {
                    clearInterval(this.interval);
                    // this.props.setCurrentView("payrolloverview");
                    this.props.enqueueSnackbar(
                      error.response
                        ? error.response.data.error.message
                        : error.message,
                      { variant: "error" },
                    );
                  },
                );
              });
          },
        );
      }
    } else {
      this.props.enqueueSnackbar("Please select at least one employee", {
        variant: "error",
      });
    }
  };


  autoUnPaid = () => {
    const { drawerData = [], errors: { empattendance = [] } } = this.state;
    const allrecords = empattendance && empattendance.filter((x) => drawerData.find((y) => y.isexpanded && y.employeeid === x.employeeid));

    const postdata = [...allrecords].map((x) => x.employeeid).filter(onlyUnique).map((empid) => {
      let autounpaid = [];

      let empAttendance = allrecords && allrecords.find((x) => x.employeeid == empid) && allrecords.find((x) => x.employeeid == empid).attendance;
      for(let att of empAttendance) {
        autounpaid.push({
          employeeid : att.employeeid,
          shiftdate : att.shiftdate
        })
      }

      return {
        employeeid: empid,
        autounpaid: autounpaid
      }
    });

    if (postdata && postdata.length > 0) {
      const { issaveinprogress } = this.props.SaveInProgressReducer;
      if (!issaveinprogress) {
        this.props.setSaveProgress(true);
        this.props.closeSnackbar();
        const totalseconds = postdata.length * 2;
        const secondsforintervals = totalseconds * 1000;

        this.interval = setInterval(
          () => {
            this.setState({
              time: this.state.time + 1,
            });
            if (this.state.time > 99) {
              clearInterval(this.interval);
              this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
              this.setState({
                  time: 0,
                  loading: false,
                });
            }
          },
          secondsforintervals / 100,
        );
        this.setState(
          {
            time: 0,
            loading: true,
          },
          () => {
            instance
              .post("leaves/autobulkunpaidleave", postdata)
              .then(() => {
                this.props.removeSaveProgress();
                const newdrawerdata = empattendance && empattendance.filter(
                    (x) =>
                      !drawerData.find(
                        (y) => y.isexpanded && y.employeeid === x.employeeid,
                      ),
                  );

                const employeeid = postdata.filter((x) => x.employeeid);
                this.getData(employeeid);
                if (newdrawerdata[0]) {
                  this.setdrawerData(newdrawerdata);
                } else {
                  this.closeMissingInfoDrawer();
                }
              })
              .catch((error) => {
                this.props.removeSaveProgress();
                this.setState(
                  {
                    time: 0,
                    loading: false,
                  },
                  () => {
                    clearInterval(this.interval);
                    this.props.enqueueSnackbar(
                      error.response
                        ? error.response.data.error.message
                        : error.message,
                      { variant: "error" },
                    );
                  },
                );
              });
          },
        );
      }
    } else {
      this.props.enqueueSnackbar("Please select at least one employee", {
        variant: "error",
      });
    }
  };


  onSkip = () => {
    const {
      drawerData = [],
      errors: { empattendance = [] },
    } = this.state;
    const newdrawerdata =
      empattendance &&
      empattendance.filter(
        (x) =>
          !drawerData.find(
            (y) => y.isexpanded && y.employeeid === x.employeeid,
          ),
      );
    console.log("newdrawerdata: ", newdrawerdata);

    // this.geterrors();
    const arrEmployee = drawerData.filter(
      (x) => x.isdefaultshift && x.isexpanded,
    );
    this.props.onSkip(arrEmployee);

    this.getData(arrEmployee, false, true);
    if (newdrawerdata[0]) {
      this.setdrawerData(newdrawerdata);
    } else {
      this.closeMissingInfoDrawer();
    }
  };

  annualPackageDetailsComp = () => {
    const { isselectedemployee } = this.state;

    return (
      <div>
        <DynamicForm
          fields={textinputconverter({
            value: "",
            label: "Annual package",
            placeholder: "₹ Enter annual package",
          })}
        // onChange={(e) => this.updatePostData("policyname", e)}
        />

        <Button
          variant="contained"
          className="btn btn-primary-md-blue"
          color="primary"
        // onClick={this.props.onCancel}
        >
          Submit
        </Button>

        {isselectedemployee && (
          <Button
            variant="contained"
            className="btn btn-primary-md-yellow margin-top-12 margin-bottom-12"
            color="primary"
          // onClick={this.props.onCancel}
          >
            Postpone selected
          </Button>
        )}
      </div>
    );
  };

  eventStyleGetter(event) {
    let style;
    if (
      event.statusstring.toLowerCase().includes("p") &&
      event.statusstring.toString().length > 1
    ) {
      style = {
        backgroundColor: "#b596f7",
        color: "#fff",
        border: "0px",
        display: "block",
      };
    } else if (
      event.statusstring.toLowerCase().includes("a") &&
      event.statusstring.toString().length > 1
    ) {
      style = {
        backgroundColor: "#b596f7",
        color: "#fff",
        border: "0px",
        display: "block",
      };
    } else if (event.statusstring.toLowerCase() == "p") {
      style = {
        backgroundColor: "#1e8ced",
        color: "#fff",
        border: "0px",
        display: "block",
      };
    } else if (event.statusstring.toLowerCase() == "l") {
      style = {
        backgroundColor: "#faa500",
        color: "#fff",
        border: "0px",
        display: "block",
      };
    } else if (event.statusstring.toLowerCase() == "w") {
      style = {
        backgroundColor: "#d9dadb",
        color: "#fff",
        border: "0px",
        display: "block",
      };
    } else if (event.statusstring.toLowerCase() == "h") {
      style = {
        backgroundColor: "#f796c0",
        color: "#fff",
        border: "0px",
        display: "block",
      };
    } else {
      style = {
        backgroundColor: "transparent",
        color: "#fff",
        border: "0px",
        display: "block",
      };
    }
    return {
      style,
    };
  }

  ExportData = () => {
    const {
      salarycycle: { displayname },
    } = this.props;
    const { employeelist } = this.state;
    const data = {
      employeeids: employeelist.map((x) => x.employeeid),
      fromdate: this.state.fromdate,
      todate: this.state.todate,
      // fromdate: "2019-12-01",
      // todate: "2019-12-31",
    };

    instance
      .post(`attendance/attendancelogpayroll`, data)
      .then((result) => {
        const intervals = [];
        let intCount = 1;
        const date1 = this.state.todate;
        const date2 = this.state.fromdate;
        // const date1 = "2019-12-31";
        // const date2 = "2019-12-01";
        const intNoOfDays = moment(date1).diff(date2, "days") + 1;
        intervals.push({ shiftdate: date2 });
        let x = date2;
        while (intNoOfDays > intCount) {
          const currentEnd = moment(x, "YYYY-MM-DD")
            .add(1, "days")
            .format("YYYY-MM-DD");
          intervals.push({ shiftdate: currentEnd });
          x = currentEnd;
          intCount += 1;
        }
        const headerobj = {
          fullname: "Employee name",
        };
        intervals.forEach((onedate, i) => {
          headerobj[`shiftdate${i + 1}`] = onedate.shiftdate;
        });
        headerobj.totaldays = "Total days";
        headerobj.presentdays = "Present days";
        headerobj.leavedays = "Leave days";
        headerobj.absentdays = "Absent days";

        const allrows = [
          headerobj,
          ...result.data.result.map((emp) => {
            const obj = {
              fullname: emp.fullname,
            };
            emp.employeeattendancelogs.forEach((log, i) => {
              obj[`shiftdate${i + 1}`] = log.statusstring;
            });
            const presentobj = emp.overview.find((x) => x.statusid == 1);
            const leaveobj = emp.overview.find((x) => x.statusid == 2);
            const absentobj = emp.overview.find((x) => x.statusid == 3);
            obj.totaldays = emp.employeeattendancelogs.length;
            obj.presentdays = presentobj && presentobj.displayvalue;
            obj.leavedays = leaveobj && leaveobj.displayvalue;
            obj.absentdays = absentobj && absentobj.displayvalue;
            return obj;
          }),
        ];
        ExportArrearsXLSX({
          rows: allrows,
          name: displayname,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  submitPaymentType = () => {
    const { paymentType } = this.state;
    console.log("paymentType: ", paymentType);
    const { drawerData } = this.state;

    const { salarycycle, payrollcycledurationid } = this.props;
    // const thisempdata = drawerData.find((x) => x.isexpanded);
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    console.log("issaveinprogress: ", issaveinprogress);

    if (!issaveinprogress) {
     const data = {
        employeesalarymodes: drawerData
          .filter((x) => x.isselected)
          .map((item) => ({
            employeeid: item.employeeid,
            paymentmodetypeid: item.paymentmodetypeid,
            employeebankid: null,
          })),
        salarycycleid: salarycycle.salarycycleid,
        salarycyclesplitid: salarycycle.displayvalue,
        payrollcycledurationid,
      };
      if (!this.state.paymentType) {
        this.props.enqueueSnackbar(
          "Please select payment mode",
          {
            variant: "error",
          },
        );
      } else {
        this.props.setSaveProgress(true);
        instance
          .post("payroll/createtempsalarymode", data)
          .then(() => {
            this.props.removeSaveProgress();
            this.setState({ paymentType: null });
            this.setdrawerData(drawerData.filter((x) => !x.isselected));
            // this.props.geterrors();
            this.getData(
              drawerData.filter((x) => x.isselected),
              true,
            );
            drawerData.filter((x) => !x.isselected).length < 1 &&
              this.closeMissingInfoDrawer();
          })
          .catch((error) => {
            this.props.removeSaveProgress();
            this.props.enqueueSnackbar(
              error.response ? error.response.data.error.message : error.message,
              { variant: "error" },
            );
          });
      }
    }
  };

  attendanceDetailsComp = () => {
    const { isselectedemployee } = this.state;

    return (
      <div>
        {isselectedemployee && (
          <div>
            <Button
              variant="contained"
              className="btn btn-primary-md-yellow margin-right-16"
              color="primary"
            // onClick={this.props.onCancel}
            >
              Mark as LOP
            </Button>
            <Button
              variant="contained"
              className="btn btn-primary-md-yellow margin-right-16"
              color="primary"
            // onClick={this.props.onCancel}
            >
              Mark as present
            </Button>
          </div>
        )}
      </div>
    );
  };

  Navigate = (date, x, y) => {
    console.log("date, x, y: ", date, x, y);
    this.setState({
      defaultdate:
        moment(date).format("MM") ==
          moment(this.state.fromdate, "YYYY-MM-DD").format("MM")
          ? this.state.fromdate
          : this.state.todate,
    });
  };

  render() {
    const {
      errors = [],
      drawerType,
      searchkey = "",
      employeelist = [],
      empdata = [],
      searchValue = "",
      fromdate = "",
      todate = "",
      defaultdate = "",
    } = this.state;
    const {
      salarycycle: { attendancecycletypeid },
    } = this.props;
    const drawerDatatemp = this.state.drawerData || [];
    console.log("this.state.drawerData : ", this.state.drawerData);
    console.log("drawerDatatemp: ", drawerDatatemp);
    const drawerData = searchkey
      ? drawerDatatemp &&
      drawerDatatemp.filter((x) => x.fullname.search(searchkey))
      : drawerDatatemp;
    console.log("drawerData: ", drawerData);
    const iserror =
      errors &&
      ((errors.empbanking && errors.empbanking[0]) ||
        (errors.empsalary && errors.empsalary[0]) ||
        (!this.state.noattendance &&
          errors.empattendance &&
          errors.empattendance[0]));

    return (
      <div>
        <div>
          <Grid container className="margin-top-16">
            <Grid item xs={12} md={7} sm={12} className="position-rel">
              <div style={{ position: "absolute", top: -44 }}>
                <PageHeader header="Step 2: Generate payroll data" />
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            className="margin-top-16"
            spacing={3}
            style={{ marginBottom: 32 }}
          >
            {iserror && (
              <Grid item xs={12} md={5} sm={12} className="position-rel">
                {errors && errors.empbanking && errors.empbanking[0] && (
                  <Paper className="rounded-rectangle-paper padding16 margin-bottom-8">
                    <p className="normal-dark-secondary">
                      <strong>{errors.empbanking.length} employee(s)</strong>
                      have missing data. You can fill in missing payment details
                      to resolve this issue, or postpone payroll for all such
                      employees.
                    </p>
                    <Button
                      className="btn btn-secondary-md-yellow margin-top-16"
                      variant="contained"
                      onClick={() => this.openMissingInfoDrawer("banking")}
                    >
                      Take action
                    </Button>
                  </Paper>
                )}
                {errors && errors.empsalary && errors.empsalary[0] && (
                  <Paper className="rounded-rectangle-paper padding16 margin-bottom-8">
                    <p className="normal-dark-secondary">
                      <strong>{errors.empsalary.length} employee(s)</strong>
                      have not been assigned a salary structure. You can assign
                      a salary structure to resolve this issue, or postpone
                      payroll for all such employees.
                    </p>
                    <Button
                      className="btn btn-secondary-md-yellow margin-top-16"
                      variant="contained"
                      onClick={() =>
                        this.openMissingInfoDrawer("salarystructure")
                      }
                    >
                      Take action
                    </Button>
                    <Button
                      className="btn btn-secondary-md-yellow margin-top-16 margin-left-16"
                      variant="contained"
                      onClick={() =>
                        this.onConfirmSkipSalaryError()
                      }
                    >
                      Skip
                    </Button>
                  </Paper>
                )}

                {errors &&
                  errors.empattendance &&
                  errors.empattendance[0] &&
                  !this.state.noattendance && (
                    <Paper className="rounded-rectangle-paper padding16 margin-bottom-8">
                      <p className="normal-dark-secondary">
                        <strong>
                          {uniqBy(errors.empattendance, "employeeid").length}{" "}
                          employee(s){" "}
                        </strong>
                        have missing attendance updates. You can mark as present
                        or loss of pay for all such employees.
                      </p>
                      <Button
                        className="btn btn-secondary-md-yellow margin-top-16"
                        variant="contained"
                        onClick={() => this.openMissingInfoDrawer("attendance")}
                      >
                        Take action
                      </Button>
                    </Paper>
                  )}
              </Grid>
            )}
            <Grid
              item
              xs={12}
              md={iserror ? 7 : 12}
              sm={12}
              className="display-flex"
              style={{ flexDirection: "column", alignItems: "center" }}
            >
              <div>
                <img src={generatedDataImg} style={{ height: 260 }}></img>
              </div>
              <div>
                <div className="display-flex"    style={{ alignItems: "center", marginTop:16 }}>
                  <div>
                    <DynamicForm
                      fields={checkboxinputconverter({
                        value: this.state.isaccepted,
                      })}
                      onChange={(val) => {
                        this.setState({
                          isaccepted: val,
                        });
                      }}
                    />
                  </div>
                  <p
                    className="small-dark-secondary t-bold"
                   style={{marginBottom:16}}
                  >
                    {/* I confirm that I've revised all salaries for the past and
                    current month */}
                    I confirm that I have reviewed the payroll configurations
                    and salary settings of past/current months
                  </p>
                </div>
                <div >
                  <p
                    className="extra-small-dark-secondary text-align-left t-bold"
                    style={{
                      cursor: "pointer",

                      marginLeft: 2,
                      fontSize: 14,
                    }}
                  >
                    <span
                      className="view-more-link"
                      style={{ color: "#1e8ced" }}
                      onClick={() => {
                        this.props.setCurrentView("home");
                        if (this.props.initdata.payrolltypeid != 3) {
                          window.open("../../../../../planner/payroll");
                        } else {
                          window.open("../../../../../live_data/proration");
                        }
                      }}
                    >
                      Click here&nbsp;
                    </span>
                    to revise salary (if any)
                  </p>
                </div>
              </div>
              <p
                className="normal-dark-secondary t-bold margin-top-24 margin-bottom-16"
                style={{ color: "#008985", marginLeft: -73 }}
              >
                Succesfully compiled employee data
              </p>
              <div style={{ width: 360 }}>
                <div className="margin-bottom-10">
                  <p className="normal-dark floatleft t-bold">
                    Analyzed employee particulars
                  </p>
                  <p className="floatright normal-dark">
                    {errors && errors.empbanking[0] ? "❗️" : "😊"}
                  </p>
                  {/* <p className="floatright normal-dark">🔍</p> */}
                  <div className="clear-float"></div>
                </div>
                <div className="margin-bottom-10">
                  <p className="normal-dark-disabled floatleft t-bold">
                    Checked salary structures
                  </p>
                  <p className="floatright normal-dark">
                    {errors && errors.empsalary[0] ? "❗️" : "😊"}
                  </p>
                  {/* <p className="floatright normal-dark">😊</p> */}
                  <div className="clear-float"></div>
                </div>
                {!this.state.noattendance && (
                  <div>
                    <p className="normal-dark-disabled floatleft t-bold">
                      Evaluated employee attendance
                    </p>
                    <p className="floatright normal-dark">
                      {errors && errors.empattendance[0] ? "❗️" : "😊"}
                    </p>
                    {/* <p className="floatright normal-dark">❗️</p> */}
                    <div className="clear-float"></div>
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        </div>
        <div className="width100">
          <div>
            <div className="floatleft" style={{ marginLeft: 172 }}>
              <div
                className="width100"
                style={{
                  position: "fixed",
                  left: 0,
                  background: "white",
                  bottom: 0,
                  padding: 10,
                  borderTop: "1px solid #d4d4d4",
                  zIndex: 0,
                }}
              >
                <div>
                  <div className="floatleft" style={{ marginLeft: 172 }}>
                    {!this.state.scanningCompleted ? (
                      <Button
                        className="btn btn-secondary-md-blue margin-right-16"
                        variant="contained"
                        onClick={() => this.props.setCurrentView("home")}
                      >
                        Cancel
                      </Button>
                    ) : null}
                  </div>
                  <div className="floatright" style={{ marginRight: 72 }}>
                    {this.state.scanningCompleted ? (
                      <Button
                        className="btn btn-primary-md-blue"
                        variant="contained"
                      // onClick={onPrev}
                      >
                        Refresh data gathering
                      </Button>
                    ) : (
                        <div>
                          <Button
                            className="btn btn-secondary-md-blue margin-right-16"
                            variant="contained"
                            onClick={this.openAttendanceDrawer}
                          >
                            View attendance sheet
                        </Button>
                          <Button
                            className="btn btn-primary-md-blue"
                            variant="contained"
                            disabled={iserror || !this.state.isaccepted}
                            onClick={() => 
                              this.props.setCurrentView("salaryadjustment")
                            }
                          >
                            Continue
                        </Button>
                        </div>
                      )}
                  </div>
                  <div className="clearfloat"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Drawer
          anchor="right"
          open={drawerType}
          onClose={this.closeMissingInfoDrawer}
          style={{ padding: 40 }}
          classes={{
            paper: "planner-drawer padding15 width25",
          }}
        >
          <DrawerHeader
            header={
              drawerType === "banking"
                ? "Missing information"
                : drawerType === "salarystructure"
                  ? "Missing salary structure"
                  : "Incomplete attendance"
            }
            isbackarrow={false}
            closeDrawer={this.closeMissingInfoDrawer}
          />
          {drawerType === "banking" && (
            <p className="normal-dark-secondary margin-bottom-8">
              You can fill in missing bank details, or postpone payroll for
              selected employees.
            </p>
          )}
          {drawerType === "salarystructure" && (
            <p className="normal-dark-secondary margin-bottom-8">
              You can assign a salary structure to resolve this issue, or
              postpone payroll for selected employees.
            </p>
          )}
          {drawerType === "attendance" && (
            <p className="normal-dark-secondary margin-bottom-8">
              You can mark as present or loss of pay for all such employees.
            </p>
          )}
          {drawerType !== "attendance" && (
            <SearchSq
              placeholder="Search employees..."
              value={this.state.searchValue}
              onChange={(e) => {
                this.setState({
                  searchValue: e.target.value || "",
                });
              }}
            />
          )}
          {(drawerType === "attendance" || drawerType === "banking") &&
            drawerData &&
            (drawerType === "attendance" ||
              drawerData.filter((x) => x.isdefaultshift).length > 0 ||
              drawerType === "banking" ||
              drawerData.filter((x) => x.isselected).length > 0) && (
              <div className="display-flex margin-top-8" style={{ height: 24 }}>
                <div
                  className="margin-right-8 bankingdrawer"
                  style={{ marginLeft: 15 }}
                >
                  <DynamicForm
                    fields={checkboxinputconverter({
                      value:
                        drawerType === "attendance"
                          ? drawerData.filter((x) => x.isdefaultshift).length >
                            0 &&
                            drawerData.filter((x) => x.isdefaultshift).length ==
                            drawerData.filter(
                              (x) => x.isdefaultshift && x.isexpanded,
                            ).length
                            ? true
                            : false
                          : drawerType === "banking"
                            ? drawerData.length ==
                              drawerData.filter((x) => x.isselected).length
                              ? true
                              : false
                            : false,
                    })}
                    onChange={() => {
                      const temp = drawerData.map((x) => ({
                        ...x,
                        isexpanded: drawerData.find((x1) => !x1.isdefaultshift)
                          ? false
                          : drawerData.find((x1) => !x1.isexpanded) &&
                            drawerType === "attendance"
                            ? true
                            : false,
                        isselected: drawerData.find((x1) => !x1.isselected)
                          ? true
                          : false,
                        // isexpanded: drawerData && drawerData.filter((x1) => x1.isdefaultshift).length ==
                        // drawerData.filter((x1) => x1.isdefaultshift && x1.isexpanded).length
                        // ? false
                        // : true,
                      }));
                      this.setState({
                        drawerData: temp,
                      });
                    }}
                  />
                </div>
                <p className="t-bold" style={{ marginTop: 1 }}>
                  Select all
                </p>
              </div>
            )}
          <div
            className="margin-top-8 thin-scroll"
            style={{ overflowY: "auto", height: "calc(95vh - 230px)" }}
          >
            {drawerData &&
              drawerData
                .filter(
                  (x) =>
                    !searchValue ||
                    (searchValue &&
                      x.fullname
                        .toLowerCase()
                        .search(searchValue.toLowerCase()) !== -1),
                )
                .map((emp, index) => (
                  <div
                    className={
                      emp.isexpanded ? "details-list-expanded" : "details-list"
                    }
                  >
                    <div>
                      <div className="info-row">
                        <div className="floatleft margin-right-8">
                          {drawerType === "banking" && (
                            <DynamicForm
                              fields={checkboxinputconverter({
                                value: emp.isselected,
                              })}
                              onChange={() => {
                                let idx = index;
                                if (searchValue) {
                                  idx = drawerData.findIndex(
                                    (x) => emp.employeeid == x.employeeid,
                                  );
                                }
                                const temp = drawerData;
                                temp[idx].isselected = !emp.isselected;
                                this.setState({
                                  drawerData: temp,
                                });
                              }}
                            />
                          )}
                          <div
                            className={
                              drawerType === "attendance"
                                ? emp.isexpanded
                                  ? "padding-left-4"
                                  : "padding-left-4 checkbox-div"
                                : "padding-left-4"
                            }
                          >
                            {drawerType === "attendance" && (
                              <DynamicForm
                                fields={checkboxinputconverter({
                                  value: emp.isexpanded,
                                  disabled: !emp.isdefaultshift,
                                })}
                                onChange={() => {
                                  const temp = drawerData;
                                  temp[index].isexpanded = !emp.isexpanded;
                                  this.setState({
                                    drawerData: temp,
                                  });
                                }}
                              />
                            )}
                          </div>
                          <div
                            className={
                              drawerType === "attendance" &&
                              !emp.isexpanded &&
                              "employee-img"
                            }
                          >
                            {drawerType !== "attendance" ||
                              (!emp.isexpanded && (
                                <ProfilePictureSmall
                                  src={getFormattedImageLink(emp.imagepath)}
                                />
                              ))}
                          </div>
                        </div>
                        <div className="floatleft">
                          <p className="small-blue t-bold">{emp.fullname}</p>
                          <p className="small-dark-secondary">
                            {emp.designationname}
                          </p>
                          {drawerType === "attendance" && (
                            <p
                              className="small-dark-secondary"
                              style={{ color: "red" }}
                            >
                              {!emp.isdefaultshift
                                ? "(Shift not assigned)"
                                : ""}
                            </p>
                          )}
                        </div>
                        {(drawerType === "banking" ||
                          (this.props.initdata.payrolltypeid != 3 &&
                            drawerType === "salarystructure")) && (
                            <img
                              src={emp.isexpanded ? downArrow : rightArrow}
                              className="floatright cursor-pointer"
                              style={{ marginTop: 11 }}
                              onClick={() =>
                                this.setState({
                                  drawerData: drawerData.map((x) => ({
                                    ...x,
                                    isexpanded:
                                      x.employeeid == emp.employeeid &&
                                      drawerData.filter((x) => x.isselected)
                                        .length == 0,
                                  })),
                                  structurepostdata: STRUCTUREPOSTDATA,
                                })
                              }
                            />
                          )}
                        <div className="clear-float"></div>
                      </div>
                      <Collapse
                        in={
                          emp.isexpanded &&
                          drawerData.filter((x) => x.isselected).length == 0
                        }
                        timeout="auto"
                        unmountOnExit
                      >
                        {emp.isexpanded && drawerType === "banking" && (
                          <div>{this.paymentDetailsComp()}</div>
                        )}
                        {emp.isexpanded && drawerType === "salarystructure" && (
                          <div>{this.salaryStructureDetailsComp()}</div>
                        )}
                        {emp.isexpanded && drawerType === "attendance" && (
                          <div>{this.attendanceDetailsComp()}</div>
                        )}
                      </Collapse>
                    </div>
                  </div>
                ))}
          </div>

          {drawerType == "attendance" &&
            drawerData.find((x) => !x.isdefaultshift) && (
              <p
                className="view-more-link text-align-left margin-top-16 margin-left-8"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  this.props.setCurrentView("home");
                  window.open("../../../../../planner/shiftplanner");
                }}
              >
                Assign shift here
              </p>
            )}
          {drawerType == "salarystructure" &&
            this.props.initdata.payrolltypeid == 3 &&
            drawerData &&
            drawerData.length > 0 && (
              <p
                className="view-more-link margin-top-16 margin-left-8 cursor-pointer"
                onClick={() => {
                  this.props.setCurrentView("home");
                  window.open("../../../../../live_data/proration");
                }}
              >
                Assign proration here
              </p>
            )}

          {drawerType == "attendance" && (
            <div>
              <Button
                variant="contained"
                className="btn btn-primary-md-yellow margin-left-8 margin-top-12"
                color="primary"
                disabled={this.props.SaveInProgressReducer.issaveinprogress}
                onClick={this.autoRegularize}
              >
                Regularize
              </Button>

              <Button
                variant="contained"
                className="btn btn-primary-md-yellow margin-left-8 margin-top-12"
                color="primary"
                disabled={this.props.SaveInProgressReducer.issaveinprogress}
                onClick={this.autoUnPaid}
              >
                Auto Unpaid
              </Button>

              {drawerData.filter((x) => x.isexpanded && x.isdefaultshift)
                .length != drawerData.filter((x) => x.isdefaultshift).length &&
                drawerData.filter((x) => x.isexpanded && x.isdefaultshift)
                  .length > 0 && (
                  <Button
                    variant="contained"
                    className="btn btn-primary-md-blue margin-left-8 margin-top-12"
                    color="primary"
                    onClick={this.onSkip}
                  >
                    Skip
                  </Button>
                )}
            </div>
          )}

          {drawerType == "banking" &&
            drawerData.filter((x) => x.isselected).length > 0 && (
              <div className="margin-top-10" style={{ marginBottom: 64 }}>
                <DynamicForm
                  fields={selectinputconverter({
                    value: this.state.paymentType,
                    options: [
                      { displayname: "Cash", displayvalue: 60 },
                      { displayname: "Cheque", displayvalue: 61 },
                    ],
                    placeholder: "Select payment method",
                    label: "Payment method",
                  })}
                  onChange={(e) => {
                    this.setState({
                      paymentType: e,
                      drawerData: drawerData.map((x) => ({
                        ...x,
                        paymentmodetypeid: x.isselected && e,
                      })),
                    });
                  }}
                />
                <div className="upform-footer">
                  <Button
                    variant="contained"
                    className="btn btn-primary-sm-blue"
                    onClick={this.submitPaymentType}
                    disabled={this.props.SaveInProgressReducer.issaveinprogress}
                  // onClick={this.AddBankDetails.bind(this)}
                  >
                    <FormattedMessage id="BtSave" defaultMessage="Save" />
                  </Button>
                  <span className="margin-left-16"></span>
                  <Button
                    className="btn btn-trans"
                    onClick={() => {
                      const temp = drawerData.map((x) => ({
                        ...x,
                        isselected: false,
                      }));
                      this.setState({
                        drawerData: temp,
                      });
                    }}
                  >
                    <FormattedMessage id="BtCancel" defaultMessage="Cancel" />
                  </Button>
                </div>
              </div>
            )}
        </Drawer>

        <Drawer
          anchor="right"
          open={this.state.attendanceDrawerOpen}
          onClose={this.closeMissingInfoDrawer}
          style={{ padding: 40 }}
          classes={{
            paper: "planner-drawer padding15 width50",
          }}
        >
          <DrawerHeader
            header="Attendance logs"
            isbackarrow={false}
            closeDrawer={this.closeAttendanceDrawer}
          />
          <Grid container spacing={3}>
            <Grid item xs={12} md={4} sm={12}>
              <SearchSq
                placeholder="Search employee"
                value={this.state.searchValue}
                onChange={(e) => {
                  this.setState({
                    searchValue: e.target.value || "",
                  });
                }}
              />
              <div
                className="employee-table thin-scroll"
                style={{ overflowY: "auto" }}
              >
                {employeelist &&
                  employeelist
                    .filter(
                      (x) =>
                        !searchValue ||
                        (searchValue &&
                          x.empfullname
                            .toLowerCase()
                            .search(searchValue.toLowerCase()) !== -1),
                    )
                    .map((emp) => (
                      <div
                        // className="employee-row"
                        className={
                          this.state.selectedEmp == emp.employeeid
                            ? "employee-row-selected"
                            : "employee-row"
                        }
                        onClick={() => this.getAttendanceLog(emp.employeeid)}
                      >
                        <div className="floatleft margin-right-8">
                          <ProfilePictureExtraSmall
                            src={DefaultProfileImage}
                            heigh
                            className="vertical-middle"
                          />
                        </div>
                        <p className="small-dark-secondary floatleft margin-top-4">
                          {emp.empfullname}
                        </p>
                        <div className="clear-float"></div>
                      </div>
                    ))}
              </div>
            </Grid>
            <Grid item xs={12} md={8} sm={12} style={{ marginBottom: 32 }}>
              {empdata && empdata.length > 0 ? (
                <div>
                  <div
                    className="margin-right-8 floatleft"
                    onClick={this.ExportData}
                  >
                    <IconWithBackground imgsrc={downloadIcon} />
                  </div>
                  <div
                    className="attendance-data-payroll"
                    style={{ marginLeft: 60, marginBottom: 24 }}
                  >
                    <BigCalendar
                      localizer={localizer}
                      events={this.state.empdata}
                      view="month"
                      views={["month"]}
                      defaultDate={new Date(defaultdate)}
                      date={new Date(defaultdate)}
                      // defaultDate={new Date("2019-12-10")}
                      // date={new Date("2019-12-10")}
                      step={60}
                      min={new Date(fromdate)}
                      max={new Date(todate)}
                      // min={new Date("2019-12-01")}
                      // max={new Date("2019-12-31")}
                      // min={moment(new Date()).startOf("month").format('YYYY-MM-DD')}
                      // max={moment(new Date()).endOf("month").format('YYYY-MM-DD')}
                      eventPropGetter={this.eventStyleGetter}
                      components={{
                        toolbar:
                          moment(fromdate, "YYYY-MM-DD").format("MM") !=
                            moment(todate, "YYYY-MM-DD").format("MM")
                            ? ToolBars({
                              min: new Date(fromdate),
                              max: new Date(todate),
                            })
                            : CustomToolbar,
                        // event: EventComponent,
                      }}
                      onNavigate={(date, view, action) =>
                        this.Navigate(date, view, action)
                      }
                    />
                  </div>
                  <div className="margin-top-32 text-align-center">
                    <div className="present-event">
                      <span className="event-p-show">P</span>
                      <span className="event-p-hide">Present</span>
                    </div>
                    <div className="leave-event">
                      <span className="event-l-show">L</span>
                      <span className="event-l-hide">Leave</span>
                    </div>
                    <div className="weekoff-event">
                      <span className="event-w-show">W</span>
                      <span className="event-w-hide">Week Off</span>
                    </div>
                    <div className="holiday-event">
                      <span className="event-h-show">H</span>
                      <span className="event-h-hide">Holiday</span>
                    </div>
                    <div className="presentwork-event">
                      <span className="event-ph-show">PH</span>
                      <span className="event-ph-hide">Present Holiday</span>
                    </div>
                  </div>
                  <div>
                    <div
                      className={
                        this.state.chartdataValue.length > 0
                          ? "expense-chart1"
                          : "expense-nodata-outer"
                      }
                    >
                      {this.state.chartdataValue.length > 0 ? (
                        <Doughnut
                          data={{
                            labels: this.state.chartdataLabels,
                            datasets: [
                              {
                                label: `Total days ${moment(
                                  defaultdate,
                                  "YYYY-MM-DD",
                                )
                                  .endOf("month")
                                  .format("DD")}`,
                                data: this.state.chartdataValue,
                                backgroundColor: ["#1e8ced", "#faa500"],
                              },
                            ],
                          }}
                          width="150px"
                          height="100px"
                          options={{
                            rotation: 100,
                            animation: {
                              animateRotate: true,
                            },
                            tooltips: {
                              footerFontSize: 16,
                              titleFontSize: 16,
                              bodyFontSize: 16,
                            },
                            title: {
                              display: true,
                              text: `Total days ${moment(
                                defaultdate,
                                "YYYY-MM-DD",
                              )
                                .endOf("month")
                                .format("DD")}`,
                              position: "top",
                              fontSize: 16,
                            },
                            legend: {
                              display: true,
                              position: "bottom",
                              fullWidth: false,
                              labels: {
                                fontFamily: "Muli",
                                fontSize: 16,
                              },
                            },
                          }}
                        />
                      ) : (
                          <div className="text-align-center expense-nodata-inner"></div>
                        )}
                    </div>
                  </div>
                </div>
              ) : (
                  <div className="position-rel width100">
                    <DefaultComp
                      heading="No logs available!"
                      imageSrc={emptylist}
                    />
                  </div>
                )}
            </Grid>
          </Grid>
        </Drawer>

        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={this.state.loading}
          // onClose={() => this.setState({ openDialog: false, empform1: null })}
          aria-labelledby="max-width-dialog-title"
          classes={{
            scrollPaper: "no-shadow bg-transparent",
            paper: "no-shadow bg-transparent",
          }}
        >
          <DialogContent>
            <div
              className="progess-wrapper"
              style={{
                position: "relative",
                width: 120,
                height: 120,
                margin: "0 auto",
                color: "#fff",
              }}
            >
              <CircularProgress
                className="goal-progress"
                variant="static"
                size={100}
                value={parseInt(this.state.time)}
                color="inherit"
              />
              <div
                className="progress-line"
                style={{ borderColor: "#fff" }}
              ></div>
              <div
                className="vertical-center text-center"
                style={{ height: 30 }}
              >
                <span
                  style={{
                    display: "block",
                    fontSize: 24,
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                >
                  {this.state.time}%
                </span>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default connect()(
  withStyles(styles, { withTheme: true })(withSnackbar(AnalysedData)),
);
